import type { Complexity } from '@/shared/utils/format-status.js';

export const COMPLEXITY_OPTIONS: Complexity[] = ['MUITO_BAIXA', 'BAIXA', 'MEDIA', 'ALTA', 'MUITO_ALTA'];

const COMPLEXITY_RANK = Object.fromEntries(COMPLEXITY_OPTIONS.map((complexity, index) => [complexity, index])) as Record<Complexity, number>;

export function isSuperiorEstimate(params: { estimatedHours: number; complexity: Complexity; functionalHours: number | null; functionalComplexity: Complexity | null }): boolean {
    const baselineAbsent = params.functionalHours === null && params.functionalComplexity === null;
    if (baselineAbsent) {
        return true;
    }
    const hoursSuperior = params.functionalHours !== null && params.estimatedHours > params.functionalHours;
    const complexitySuperior = params.functionalComplexity !== null && COMPLEXITY_RANK[params.complexity] > COMPLEXITY_RANK[params.functionalComplexity];
    return hoursSuperior || complexitySuperior;
}
